import { render, staticRenderFns } from "./waiting.vue?vue&type=template&id=a6dad4a0&"
import script from "./waiting.vue?vue&type=script&lang=js&"
export * from "./waiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports